import _ from "lodash";
import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import EmployeeAccountItem from "./EmployeeAccountItem";
import { EmployeeAccountFormModal } from "../../containers";
import { retrieveSubAccounts } from "../../modules";
import { AuthenticatedPage } from "../../../common";

import styled from "styled-components";
const PageTitle = styled.div`
  text-align: center;
  font-family: Secular One;
  font-size: 1.5em;
  margin-top: 24px;
`;
const EmployeeAccountsList = styled.div`
  padding: 16px 10% 16px 10%;
`;
const EmployeeAccountToolbar = styled.div`
  border-radius: 20px;
  background: #54d0d5;
  margin-bottom: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 8px 4px 8px;
`;
const FilterSubAccount = styled.input`
  background: #ffffff;
  border: 1px solid #e5e5e5;
  box-sizing: border-box;

  border-radius: 20px;
  height: 50px;
  width: 100%;
  margin-right: 16px;

  :focus {
    outline: none;
    box-shadow: 0px 0px 2px #0066ff;
  }
  ::placeholder {
    font-family: Secular One;
    color: #929292;
  }
  color: #929292;
  padding-left: 16px;
`;
const AddSubAccountButton = styled.button`
  background: #039095;
  border-radius: 250.251px;
  font-size: 0.8em;
  font-family: Secular One;
  color: #ffffff;
  align-items: center;
  text-align: center;
  letter-spacing: 0.05em;
  padding: 16px;
  :focus {
    outline: none;
    box-shadow: 0px 0px 2px #0066ff;
  }

  cursor: pointer;
  :hover {
    background: #01858a;
  }
`;

const ManageSubAccountsPage = (props) => {
  const history = useHistory();
  const contentRef = useRef();

  const [
    newEmployeeAccountModalOpen,
    setNewEmployeeAccountModalOpen,
  ] = useState(false);

  useEffect(() => {
    const values = {
      auth_token: _.get(props.credentials, "authToken"),
    };

    props.retrieveSubAccounts({ values });
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const employeeAccounts = _.get(props, "subAccounts", []).map(
    (sAccount, index) => {
      return <EmployeeAccountItem key={index} subAccount={sAccount} />;
    }
  );

  return (
    <AuthenticatedPage
      history={history}
      ref={contentRef}
      breadcrumbPath={[{ label: "Employee Accounts", url: "/manage-accounts" }]}
    >
      <PageTitle>MANAGE EMPLOYEE ACCOUNTS</PageTitle>

      <EmployeeAccountsList>
        <EmployeeAccountToolbar>
          <FilterSubAccount placeholder={"FILTER EMPLOYEE ACCOUNTS..."} />
          <AddSubAccountButton
            onClick={() => {
              setNewEmployeeAccountModalOpen(true);
            }}
          >
            NEW EMPLOYEE ACCOUNT
          </AddSubAccountButton>
        </EmployeeAccountToolbar>
        {employeeAccounts}
      </EmployeeAccountsList>
      <EmployeeAccountFormModal
        title={"CREATE A NEW EMPLOYEE ACCOUNT"}
        isOpen={newEmployeeAccountModalOpen}
        handleClose={() => {
          setNewEmployeeAccountModalOpen(false);
        }}
      />
    </AuthenticatedPage>
  );
};

const mapStateToProps = (state) => ({
  credentials: state.lib_authentication.credentials,
  subAccounts: state.lib_sub_account.subAccounts,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      retrieveSubAccounts,
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageSubAccountsPage);
